export default __webpack_public_path__ + "images/logo-era-alaska.ebe2709.png";